<template>
  <BaseModal col-md="col-md-6" offset="3" subtitulo="Informações"
             modalColor="border-primary bg-success">
    <template v-slot:modalContent>
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li>
            <a class="nav-link active" data-toggle="tab" href="#tab-1"
               id="infoTabs">Informações</a>
          </li>
          <li>
            <a class="nav-link" data-toggle="tab" href="#tab-2" id="solicitacoesTab">Solicitações - Respostas</a>
          </li>
          <li>
            <a class="nav-link" data-toggle="tab" href="#tab-3"
               id="imgTabs">Imagens</a>
          </li>
        </ul>
        <div class="tab-content">
          <div id="tab-1" class="tab-pane active">
            <div class="panel-body">
              <InformacoesCrm
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
          <div id="tab-2" class="tab-pane">
            <div class="panel-body">
              <SolicitacoesCrm
                  :itemSelect="itemSelect"
                  @fechar="$emit('fechar')"
                  @statusAtualizado="$emit('statusAtualizado', $event)"
              />
            </div>
          </div>
          <div id="tab-3" class="tab-pane">
            <div class="panel-body">
              <ImagensCrm
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import InformacoesCrm from '@/views/crm/InformacoesCrm.vue';
import SolicitacoesCrm from '@/views/crm/SolicitacoesCrm.vue';
import ImagensCrm from "@/views/crm/ImagensCrm.vue";

export default {
  name: "TabsModalImovel",
  components: {
    BaseModal,
    InformacoesCrm,
    SolicitacoesCrm,
    ImagensCrm,
  },
  props: {
    itemKey: String,
    itemSelect: Number,
  },
  emits: ['fechar', 'statusAtualizado'],
};
</script>
